// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"37ab9d97","453":"9eb00ecb","988":"bc78f17c"}[chunkId] + ".chunk.js";
};